import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

type Header = {
  label: string;
  width: string;
  visibility?: string;
  textAlign?: string;
};

type Props = {
  isBundling?: boolean;
  headers: Header[];
  justifyContent?: string;
};

const OrderFormShortHeaderRow = ({
  isBundling,
  headers,
  justifyContent = "flex-start",
}: Props) => {
  const { t } = useTranslation("order");

  return (
    <Grid
      container
      item
      spacing={1}
      alignItems="flex-end"
      wrap="nowrap"
      justifyContent={justifyContent}
    >
      {headers.map((header) =>
        header.label === "bundling" && !isBundling ? null : (
          <Grid
            item
            xs
            sx={{
              width: `${header.width}!important`,
              minWidth: `${header.width}!important`,
              maxWidth: `${header.width}!important`,
              textAlign: header.textAlign || "unset",
              visibility: header.visibility || "unset",
            }}
            key={header.label}
          >
            <Typography
              sx={{
                width: "100%",
                fontSize: "14px",
                fontWeight: 500,
                marginLeft: header.textAlign ? "-4px" : "0px",
              }}
            >
              {t(header.label)}
            </Typography>
          </Grid>
        ),
      )}
    </Grid>
  );
};

export default OrderFormShortHeaderRow;
